import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { editTimecard } from 'features/timesheets/TimesheetsPage/TimecardModal/slices';

import { momentInZone } from 'util/dateTime';
import { toI18n } from 'util/i18n';

import Issue from './Issue';

const Late = ({ issue, onChangeShift, shift, setChangesMade }) => {
  const dispatch = useDispatch();
  const handleAddClockInScheduled = useCallback(() => {
    dispatch(editTimecard());
    onChangeShift('actual_start_at', shift.get('scheduled_start_at'));
    onChangeShift('actual_end_at', null);
    setChangesMade(true);
  }, [dispatch, onChangeShift, setChangesMade, shift]);

  const handleAddClockInCurrentTime = useCallback(() => {
    dispatch(editTimecard());
    setChangesMade(true);
    onChangeShift('actual_start_at', momentInZone().format('YYYY-MM-D HH:mm'));
    onChangeShift('actual_end_at', null);
  }, [dispatch, onChangeShift, setChangesMade]);

  const options = [
    {
      label: toI18n('timecard_modal_v3.issues.late.add_clock_in_scheduled'),
      color: 'navy',
      paddingLeft: 18,
      onClick: () => handleAddClockInScheduled(),
    },
    {
      label: toI18n('timecard_modal_v3.issues.late.add_clock_in_current'),
      onClick: () => handleAddClockInCurrentTime(),
      color: 'navy',
      paddingLeft: 18,
    },
  ];

  return <Issue issue={issue} options={options} />;
};

export default Late;
